module.exports = __webpack_public_path__ + "static/media/Advance promotion box.26f3bfa2.jpg";